import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#1a2332] text-[#F1F1F1] pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Left Column - Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="/assets/img/brand/logo-light.png"
                alt="Trademark Essential Logo"
                className="h-12 w-auto mb-4"
              />
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Safeguarding Innovation. Protecting Identity.
            </p>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-[#FFB400] flex-shrink-0 mt-1" />
                <span>
                  7060 Hollywood Blvd
                  <br />
                  Los Angeles, CA 90028
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-[#FFB400]" />
                <span>+1 (877) 317-1184</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-[#FFB400]" />
                <span>+1 (213) 973-2126</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-[#FFB400]" />
                <span>info@trademarkessential.com</span>
              </div>
            </div>
          </div>

          {/* Trademark Services */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">
              Trademark Services
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/services/trademark/search-registration"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Search & Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/clearance"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Clearance Searches
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/application"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Application Preparation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/office-actions"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Office Actions
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/monitoring"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Monitoring
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/statement-of-use"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Statement Of Use Filings
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/ownership-change"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Change of Ownership
                </Link>
              </li>
              <li>
                <Link
                  to="/services/trademark/portfolio"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Trademark Portfolio Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Copyright Services */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">
              Copyright Services
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/services/copyright/registration"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/enforcement"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Copyright Enforcement
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/assignments"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Copyright Assignments and Licensing
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/litigation"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Copyright Litigation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/portfolio"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Copyright Portfolio Management
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/dmca"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Digital Millennium Copyright Act
                </Link>
              </li>
            </ul>
          </div>

          {/* Patent Services */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">
              Patent Services
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/services/patent/searches"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Patent Searches
                </Link>
              </li>
              <li>
                <Link
                  to="/services/patent/office-actions"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Office Actions & Amendments
                </Link>
              </li>
              <li>
                <Link
                  to="/services/patent/applications"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Patent Applications
                </Link>
              </li>
              <li>
                <Link
                  to="/services/patent/enforcement"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Patent Enforcement
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Formation */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">
              Company Formation
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/services/company/llc"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  LLC Formation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/company/c-corp"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  C Corporation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/company/s-corp"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  S Corporation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/company/non-profit"
                  className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
                >
                  Non-Profit Organization
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Left - Copyright */}
            <div>
              <p className="text-sm text-gray-400">
                © 2026 Trademark Essential. All rights reserved.
              </p>
            </div>

            {/* Right - Links */}
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy"
                className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link
                to="/terms"
                className="text-sm text-gray-400 hover:text-[#FFB400] transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
